import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import { jsPDF } from 'jspdf';

/** A6 landscape: 148 × 105 mm */
const A6_W_MM = 148;
const A6_H_MM = 105;

export async function generateQrDataUrl(text, size = 120) {
  try {
    return await QRCode.toDataURL(String(text), {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
    });
  } catch {
    return '';
  }
}

export function generateBarcodeSvg(text, { height = 48 } = {}) {
  if (typeof document === 'undefined') return '';
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  try {
    JsBarcode(svg, String(text), {
      format: 'CODE128',
      width: 1.6,
      height,
      displayValue: false,
      margin: 0,
    });
    return new XMLSerializer().serializeToString(svg);
  } catch {
    return '';
  }
}

export function stickerPdfFilename(collectionNo) {
  const no = String(collectionNo || 'stickers').replace(/[^\w.-]+/g, '_');
  return `Stickers_${no}.pdf`;
}

export async function downloadStickersPdf(sheetElements, filename) {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: [A6_W_MM, A6_H_MM],
  });

  for (let i = 0; i < sheetElements.length; i += 1) {
    if (i > 0) pdf.addPage([A6_W_MM, A6_H_MM], 'landscape');
    const el = sheetElements[i];
    const canvas = await import('html2canvas').then((m) =>
      m.default(el, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
      })
    );
    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, A6_W_MM, A6_H_MM);
  }

  pdf.save(filename);
}

export { A6_W_MM, A6_H_MM };
